import { format } from 'date-fns'
import { TranslateLocale } from './translator'
import moment from 'moment';

/**
 * Função padrão que formata um objeto de data baseado no local informado usando o date-fns.
 * @param date Objeto date a ser formatado
 * @param locale Local a ser usado na formatação
 * @param includeHours Flag que indica se a hora deve ser incluída na formatação
 * @returns string
 */
export const FormatDate = (date: Date, locale: string, includeHours: boolean = true) => {
  if (moment(date).isValid()) {

    let translatedLocale = TranslateLocale(locale)
    return format(date, `dd/MM/yyyy${includeHours ? ' hh:mm:ss' : ''}`, { locale: translatedLocale })
  } else {
    return ''
  }
}
